import universal from 'react-universal-component';

export default universal(() => import('./TeamPRM'));



// WEBPACK FOOTER //
// ./src/app/views/TeamPositionRanksMatchups/index.js